var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRowsAndColumnsOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5724 11.4997H1.9998C1.17281 11.4997 0.5 10.8269 0.5 9.9999V1.9998C0.5 1.17281 1.17281 0.5 1.9998 0.5H18C18.827 0.5 19.4998 1.17281 19.4998 1.9998V8.89536C19.0799 8.58162 18.5593 8.4001 18 8.4001H12.9996C11.6212 8.4001 10.4998 9.52151 10.4998 10.8999C10.4998 11.1037 10.5244 11.3049 10.5724 11.4997Z",
    fill: "#272C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0014 10.9997C10.0003 10.9665 9.9998 10.9332 9.9998 10.8999C9.9998 9.2458 11.3455 7.9001 12.9996 7.9001H18C18.3493 7.9001 18.6861 7.95913 18.9998 8.06883V1.9998C18.9998 1.44851 18.5513 1 18 1H1.9998C1.44851 1 1 1.44851 1 1.9998V9.9999C1 10.5512 1.44851 10.9997 1.9998 10.9997H10.0014ZM11.3292 11.9997H1.9998C0.89711 11.9997 0 11.1026 0 9.9999V1.9998C0 0.89711 0.89711 0 1.9998 0H18C19.1027 0 19.9998 0.89711 19.9998 1.9998V9.9999C19.9998 10.1518 19.9827 10.3032 19.9489 10.4499C19.739 9.5374 18.9384 8.9001 18 8.9001H12.9996C11.8969 8.9001 10.9998 9.79721 10.9998 10.8999C10.9998 11.2922 11.1134 11.6719 11.3282 11.9981L11.3292 11.9997Z",
    fill: "#272C55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4H19.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5V11.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.5V6.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9H10.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 9.90039H13.5996C13.0473 9.90039 12.5996 10.3481 12.5996 10.9004C12.5996 11.4527 13.0473 11.9004 13.5996 11.9004H17.5996C18.1519 11.9004 18.5996 11.4527 18.5996 10.9004C18.5996 10.3481 18.1519 9.90039 17.5996 9.90039Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRowsAndColumnsOperationIcon);
export default __webpack_public_path__ + "static/media/DeleteRowsAndColumnsOperationIcon.7e04f545c2bce059f935f79fd6bfe81e.svg";
export { ForwardRef as ReactComponent };